// sending camelCase to backend
export interface CybersourceSignature {
	accessKey?: string;
	profileId?: string;
	transactionUuid?: string;
	signedFieldNames?: string;
	signedDateTime?: string;
	locale?: string;
	transactionType?: string;
	referenceNumber?: string;
	unsignedFieldNames?: string;
	amount?: string;
	currency?: string;
	ignoreAvs?: string;
	paymentMethod?: string;
	billToForename?: string;
	billToSurname?: string;
	billToEmail?: string;
	billToPhone?: string;
	billToAddressLine1?: string;
	billToAddressLine2?: string;
	billToAddressCity?: string;
	billToAddressState?: string;
	billToAddressCountry?: string;
	billToAddressPostalCode?: string;
	merchantDefinedData5?: string; // transaction type
	merchantDefinedData6?: string; // cashier id
	merchantDefinedData7?: string;
	merchantDefinedData8?: string;
	merchantDefinedData9?: string;
	merchantDefinedData10?: string;
	merchantDefinedData11?: string;
	merchantDefinedData12?: string;
	signature?: string;
}

export const defaultCbsSign: CybersourceSignature = {
	accessKey: '',
	profileId: '',
	transactionUuid: '',
	signedFieldNames: '',
	signedDateTime: '',
	locale: '',
	transactionType: '',
	referenceNumber: '',
	unsignedFieldNames: '',
	amount: '',
	currency: '',
	ignoreAvs: '',
	paymentMethod: '',
	billToForename: '',
	billToSurname: '',
	billToEmail: '',
	billToPhone: '',
	billToAddressLine1: '',
	billToAddressLine2: '',
	billToAddressCity: '',
	billToAddressState: '',
	billToAddressCountry: '',
	billToAddressPostalCode: '',
	merchantDefinedData5: '',
	merchantDefinedData6: '',
	merchantDefinedData7: '',
	merchantDefinedData8: '',
	merchantDefinedData9: '',
	merchantDefinedData10: '',
	merchantDefinedData11: '',
	merchantDefinedData12: '',
	signature: '',
};
